import { InjectionToken } from '@angular/core';

/**
 * Runtime shell config shape: the API base URL + a coarse environment label.
 * Loaded at app-init (see {@link ShellConfigService}).
 */
export interface ShellRuntimeConfig {
  apiUrl: string;
  environment: string;
  /**
   * Cross-portal links for the shell's sidebar product switcher (Option B — ADO #1543).
   * Config-driven brand labels (NOT i18n'd). Deployed envs must inject these via the
   * pipeline-built `config.json` per environment (Follow-up ADO #1543).
   */
  portalLinks?: { key: string; label: string; url: string }[];
}

/**
 * The app-provided fallback used when `/assets/config.json` is missing or carries
 * unresolved placeholders. Each consuming app supplies its own (typically derived
 * from its `environment.ts`) via the {@link SHELL_CONFIG} token — the hardcoded
 * fallback deliberately does NOT live in the library so the shell stays app-agnostic.
 */
export const SHELL_CONFIG = new InjectionToken<ShellRuntimeConfig>('SHELL_CONFIG');
